import { isSameDay } from 'date-fns/isSameDay';
import { useMemo } from 'react';

import { getZonedDate } from '@eika-infrastruktur/date';

import type { PaymentItemDetails } from '../../../generated-types';
import useFormContext from '../Payment/form/useFormContext';
import useSetNoteInfo from './useSetNoteInfo';

export default (paymentDetails?: PaymentItemDetails) => {
    const { state, handleChange } = useFormContext();
    useSetNoteInfo(handleChange, paymentDetails);

    return useMemo(() => {
        return (
            paymentDetails?.amount !== state.amount ||
            paymentDetails?.from.accountNumber?.value !== state.fromAccount?.value ||
            (paymentDetails?.note || '') !== state.note ||
            (paymentDetails?.ownText ?? '') !== (state.ownText ?? '') ||
            !isSameDay(getZonedDate(paymentDetails?.dueDate), getZonedDate(state.paymentDate))
        );
    }, [
        paymentDetails?.note,
        paymentDetails?.amount,
        paymentDetails?.from.accountNumber?.value,
        paymentDetails?.ownText,
        paymentDetails?.dueDate,
        state.note,
        state.amount,
        state.fromAccount?.value,
        state.ownText,
        state.paymentDate,
    ]);
};
